<template>
  <div class="w-full">
    <hr class="mt-6 border-b-1 border-blueGray-300" />
    <div class="flex justify-between items-center pl-4">
      <h6 class="text-blueGray-400 text-sm mt-5 mb-6 font-bold uppercase">
        Hotspot
      </h6>
      <button
        @click="handleDeleteHotspot(hotspotId)"
        type="button"
        class="bg-white text-gray active:bg-white-600 font-bold uppercase text-xs px-3 py-1 mr-4 rounded-full shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
      >
        <IconDelete />
      </button>
    </div>
    <div class="flex flex-wrap">
      <div
        v-for="(value, name) in hotspotAttributes"
        :key="name"
        class="w-full lg:w-4/12 px-4"
      >
        <div class="relative w-full mb-3">
          <label
            class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
          >
            <AttrTitleWithDescription
              :title="name"
              :description="value.description"
            />
          </label>
          <SearchAndSelect
            v-if="value.type === 'product'"
            :hotspotId="hotspotId"
            :formData="formData"
          />
          <input
            v-else-if="name === 'pos_top' || 'pos_left'"
            v-model="formDataLocal.hotspots[hotspotId][`${name}`]"
            type="number"
            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
          />
          <input
            v-else
            v-model="formDataLocal.hotspots[hotspotId][`${name}`]"
            type="text"
            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconDelete from "@/assets/icons/IconDelete";
import SearchAndSelect from "@/components/Shared/Input/SearchAndSelect";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";

export default {
  name: "HotspotPanel",
  components: { IconDelete, SearchAndSelect, AttrTitleWithDescription },
  props: {
    formData: {
      type: Object,
      required: true
    },
    hotspotId: {
      type: Number,
      required: true
    },
    allSlideAttributes: {
      type: Object,
      required: true
    }
  },
  computed: {
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    hotspotAttributes() {
      if (this.allSlideAttributes) {
        let { hotspots } = this.allSlideAttributes;
        return hotspots;
      }
      return {};
    }
  },
  methods: {
    handleDeleteHotspot(index) {
      this.formDataLocal["hotspots"] = this.formDataLocal["hotspots"].filter(
        (item) => {
          return this.formDataLocal["hotspots"].indexOf(item) !== index;
        }
      );
    }
  }
};
</script>
